import _ from "lodash";

const Validator = {
    validateString(obj: { [x: string]: any }, fieldName: string): string {
        const value = obj[fieldName];
        if (typeof value !== "string") {
            throw new Error("field " + fieldName + " must be a string");
        }
        return value;
    },

    validateNullableString: function(obj: { [x: string]: any }, fieldName: string): string | null | undefined {
        const value = obj[fieldName];
        if (typeof value !== "string" && value !== null) {
            throw new Error("field " + fieldName + " must be a string or null");
        }
        return value;
    },

    validateOptionalString: function(obj: { [x: string]: any }, fieldName: string): string | null | undefined {
        const value = obj[fieldName];
        if (typeof value !== "string" && value !== null && value !== undefined) {
            throw new Error("field " + fieldName + " must be a string, null or undefined");
        }
        return value || null;
    },

    validateObject(obj: { [x: string]: any }, fieldName: string): { [x: string]: any } {
        const value = obj[fieldName];
        if (typeof value !== "object") {
            throw new Error("field " + fieldName + " must be an object");
        }
        return value;
    },

    validateOptionalObject(obj: { [x: string]: any }, fieldName: string): { [x: string]: any } | null | undefined {
        const value = obj[fieldName];
        if (typeof value !== "object" && value !== null && value !== undefined) {
            throw new Error("field " + fieldName + " must be an object");
        }
        return value || null;
    },

    validateArray(obj: { [x: string]: any }, fieldName: string, minLen?: number | null | undefined): Array<any> {
        const value = obj[fieldName];
        if (!_.isArray(value)) {
            throw new Error("field " + fieldName + " must be an array");
        }
        if (minLen && value.length < minLen) {
            throw new Error(
                "field " + fieldName + " is an array, but does not have required minimum length of " + minLen
            );
        }
        return value;
    },

    validateOptionalArray(obj: { [x: string]: any }, fieldName: string): Array<any> | null | undefined {
        const value = obj[fieldName];
        if (!_.isArray(value) && value !== null && value !== undefined) {
            throw new Error("field " + fieldName + " must be an array");
        }
        return value || [];
    },

    validateBoolean(obj: { [x: string]: any }, fieldName: string): boolean {
        const value = obj[fieldName];
        if (typeof value !== "boolean") {
            throw new Error("field " + fieldName + " must be a boolean");
        }
        return value;
    },

    validateOptionalBoolean(obj: { [x: string]: any }, fieldName: string): boolean | null | undefined {
        const value = obj[fieldName];
        if (typeof value !== "boolean" && value !== null && value !== undefined) {
            throw new Error("field " + fieldName + " must be a boolean, null or undefined");
        }
        return value;
    }
};

export default Validator;
